import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import { routeActions } from 'react-router-redux';
import classnames from 'classnames';
import { Link } from 'react-router';
import moment from 'moment';
import { Scrollbars } from 'react-custom-scrollbars';
import { logAsync } from 'helpers/elogAsync';
import { Menu, Icon } from 'antd';
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

const container = connect (
  createSelector(
    (state) => ({
      subjects: _.get(state, 'subject.entities'),
      sideBar1: _.get(state, 'subject.sideBar1'),
      sideBar2: _.get(state, 'subject.sideBar2'),
      sideBar3: _.get(state, 'subject.sideBar3'),
    }),
    (state) => {
      return {
        ...state
      }
    }
  )
)

class HomeSideBar extends Component {

  handleSubMenuClick = (e) => {
    const { dispatch, query } = this.props;
    dispatch(routeActions.push({
      pathname: '/search',
      query: {
        subjectId: e,
        startDate: moment().subtract(6, 'd').format("YYYY-MM-DD 00:00:00"),
        endDate: moment().format("YYYY-MM-DD 23:59:59"),
      }
    }))
    .then(() => {
      const {register_email} = localStorage;
      logAsync({
        type: "sPOP-click-subject",
        data: {
          subjectId: e,
          startDate: moment().subtract(6, 'd').format("YYYY-MM-DD 00:00:00"),
          endDate: moment().format("YYYY-MM-DD 23:59:59"),
          user: register_email,
        }
      })
    })
  }

  handleClick = (e) => {
    const { dispatch, query } = this.props;
    const data = e.key.split('_')
    const source = JSON.parse(data[0])

    dispatch(routeActions.push({
      pathname: '/search',
      query: {
        subjectId: data[1],
        from: source.from,
        in: source.in[0],
        sourceGroupId: source.sourceGroupId,
        startDate: moment().subtract(6, 'd').format("YYYY-MM-DD 00:00:00"),
        endDate: moment().format("YYYY-MM-DD 23:59:59"),
      }
    }))
    .then(() => {
      const {register_email} = localStorage;
      logAsync({
        type: "sPOP-click-subject",
        data: {
          subjectId: data[1],
          from: source.from,
          in: source.in[0],
          sourceGroupId: source.sourceGroupId,
          startDate: moment().subtract(6, 'd').format("YYYY-MM-DD 00:00:00"),
          endDate: moment().format("YYYY-MM-DD 23:59:59"),
          user: register_email
        }
      })
    })
  }

  render() {
    const {subjects, sideBar1, sideBar2, sideBar3} = this.props;
    return (
      <div className="subject-sidebar">
        <div>
          <Menu onClick={this.handleClick} mode="vertical">
            {_.map(_.get(sideBar1, 'data'), (subjectId, i) => {
              const subject = subjects[subjectId]
              let sources = [];
              _.map(subject.queries, (querie) => {
                _.map(querie.source, (source) => {
                  if (!_.isEmpty(source.from)) {
                    sources = [...sources, source]
                  }
                })
              })
              return (
                <SubMenu
                  onTitleClick={() => this.handleSubMenuClick(subjectId)}
                  key={i}
                  className={classnames("first-back", {"hide-icon": _.isEmpty(sources)})}
                  title={
                    <span>
                      <i className={classnames("mediaType-icon",
                        "appstore-icon",
                        {"paper--plane-icon": _.get(subject, 'name').indexOf('頭條') > -1},
                        {"bubble-icon": _.get(subject, 'name').indexOf('社論') > -1},
                        {"dialogue-icon": _.get(subject, 'name').indexOf('評論') > -1},
                        {"map-icon": _.get(subject, 'name').indexOf('副刊') > -1},
                        {"facebook-icon": _.get(subject, 'name').indexOf('Facebook') > -1}
                        )}></i>
                      <span className="sidebar-subject-name">{_.get(subject, 'name')}</span>
                    </span>}>
                  {_.map(sources, (source, j) => {
                    const key = JSON.stringify(source)
                    if(_.get(source, 'from') && !_.isEmpty(_.get(source, 'in'))){

                      return _.map(_.get(source,'in'), (item) => {
                        const query = {
                          ...source,
                          in: [item]
                        };
                        const key = JSON.stringify(query);
                        const menuItemKey = `${key}_${subjectId}`
                        return (
                          <Menu.Item key={menuItemKey}>
                             <span>[{item}]</span>
                             <span>{_.get(source, 'from')}</span>
                          </Menu.Item>
                         )
                      })

                    } else {
                      return (
                        <div></div>
                      )
                    }
                  })
                  }
                </SubMenu>
              )
            })
            }
          </Menu>
        </div>
        <div className="back-margin">
          <Menu onClick={this.handleClick} mode="vertical">
            {_.map(_.get(sideBar2, 'data'), (subjectId, i) => {
              const subject = subjects[subjectId]
              let sources = [];
              _.map(subject.queries, (querie) => {
                _.map(querie.source, (source) => {
                  if (!_.isEmpty(source.from)) {
                    sources = [...sources, source]
                  }
                })
              })
              return (
                <SubMenu onTitleClick={() => this.handleSubMenuClick(subjectId)} key={i} className={classnames("first-back", {"hide-icon": _.isEmpty(sources)})}  title={
                    <span>
                      <i className={classnames("mediaType-icon",
                        "appstore-icon",
                      {"earth-icon": _.get(subject, 'name').indexOf('國際') > -1},
                      {"money-icon": _.get(subject, 'name').indexOf('財經') > -1},
                      {"football-icon": _.get(subject, 'name').indexOf('體育') > -1},
                      {"dog-icon": _.get(subject, 'name').indexOf('娛樂') > -1},
                      {"lemon-icon": _.get(subject, 'name').indexOf('生活') > -1},
                      {"building-icon": _.get(subject, 'name').indexOf('社會') > -1},
                      {"institution-icon": _.get(subject, 'name').indexOf('政治') > -1},
                      {"phone-icon": _.get(subject, 'name').indexOf('科技') > -1},
                      {"facebook-icon": _.get(subject, 'name').indexOf('Facebook') > -1}
                      )}></i>
                      <span className="sidebar-subject-name">{_.get(subject, 'name')}</span>
                    </span>}>
                  {_.map(sources, (source, j) => {
                    const key = JSON.stringify(source)
                    if(_.get(source, 'from')) {
                      return (
                        <Menu.Item key={`${key}_${subjectId}`}>
                        <span>
                          {!_.isEmpty(_.get(source, 'in')) &&
                            <span>[{_.get(source, 'in')}]</span>
                          }
                          <span>{_.get(source, 'from')}</span>
                        </span>
                        </Menu.Item>
                      )
                    } else {
                      return (
                        <div></div>
                      )
                    }
                  })
                  }
                </SubMenu>
              )
            })
            }
          </Menu>
        </div>
        <div className="back-margin">
          <Menu onClick={this.handleClick} mode="vertical">
            {_.map(_.get(sideBar3, 'data'), (subjectId, i) => {
              const subject = subjects[subjectId]
              let sources = [];
              _.map(subject.queries, (querie) => {
                _.map(querie.source, (source) => {
                  if (!_.isEmpty(source.from)) {
                    sources = [...sources, source]
                  }
                })
              })
              return (
                <SubMenu
                  onTitleClick={() => this.handleSubMenuClick(subjectId)}
                  key={i}
                  className={classnames("first-back", {"hide-icon": _.isEmpty(sources)})}
                  title={
                    <span>
                      <i className={classnames("mediaType-icon",
                        "appstore-icon",
                        {"dialogue-two-icon": _.get(subject, 'name').indexOf('論壇') > -1},
                        {"microphone-icon": _.get(subject, 'name').indexOf('媒體') > -1},
                        {"blog-icon": _.get(subject, 'name').indexOf('博客') > -1},
                        {"recorder-icon": _.get(subject, 'name').indexOf('視頻') > -1},
                        {"side-facebook-icon": _.get(subject, 'name').indexOf('Facebook') > -1}
                        )}></i>
                      <span className="sidebar-subject-name">{_.get(subject, 'name')}</span>
                    </span>
                  }>
                  {_.map(sources, (source, j) => {
                    const key = JSON.stringify(source)
                    if(_.get(source, 'from')) {
                      return (
                        <Menu.Item key={`${key}_${subjectId}`}>
                        <span>
                          {!_.isEmpty(_.get(source, 'in')) &&
                            <span>[{_.get(source, 'in')}]</span>
                          }
                          <span>{_.get(source, 'from')}</span>
                        </span>
                        </Menu.Item>
                      )
                    } else {
                      return (
                        <div></div>
                      )
                    }
                  })
                  }
                </SubMenu>
              )
            })
            }
          </Menu>
        </div>
      </div>
    )
  }
}

export default container(HomeSideBar)



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/components/HomeSidebar.js
 **/